import React, { useContext } from 'react';
import { connect } from 'react-redux';
import ApplyOrUpgradeCta from './ApplyOrUpgradeCta.js';
import Tncs from './Tncs.js';
import LearnMoreCta from './LearnMoreCta.js';
import AddEmpCardCta from './AddEmployeeCardCta.js';
import { useBreakpoint } from '@americanexpress/aqx-components';

import { makeGetSelectedCards } from '../redux.js';
import { CurrentPermutationContext } from '../index.js';

import styles from '../__styles__/footerCta.scss?modules';

const FooterCta = ({ cards, footerRef }) => {
  const { sm } = useBreakpoint();
  const { currentPermutations } = useContext(CurrentPermutationContext);

  const visibleCards = sm
    ? [cards[currentPermutations[0] - 1], cards[currentPermutations[1] - 1]]
    : cards;

  const nonNullCards = visibleCards
    ? visibleCards.filter(card => card !== null)
    : [];
  return (
    <div className={styles.footerContainer} ref={footerRef}>
      {nonNullCards.map((card, index) => (
        <div key={`k${index}-${card.shortName}`} className={styles.eachFooter}>
          <ApplyOrUpgradeCta shortName={card} position="Bottom" />
          <LearnMoreCta shortName={card} />
          <AddEmpCardCta shortName={card} />
          <Tncs shortName={card} position="Bottom" />
        </div>
      ))}
    </div>
  );
};

const mapStateToProps = () => {
  const getSelectedCards = makeGetSelectedCards();

  return state => ({
    cards: getSelectedCards(state)
  });
};

export default connect(mapStateToProps)(FooterCta);
